import type { IconMap } from "./types";

export const defaultIcon: IconMap = ["line.symbol.circle-question", "fill.symbol.circle-question"];

export const iconsMap: Record<number, IconMap> = {
    5: ["line.facility.elevator", "fill.facility.elevator"],
    10: ["line.activity.mirrorball", "fill.activity.mirrorball"],
    11: ["line.food.fork-knife", "fill.food.fork-knife"],
    15: ["line.facility.smoke-no", "fill.facility.smoke-no"],
    16: ["line.facility.wheelchair", "fill.facility.wheelchair"],
    17: ["line.transportation.car-flight", "fill.transportation.car-flight"],
    24: ["line.facility.pet", "fill.facility.pet"],
    25: ["line.symbol.snowflake", "fill.symbol.snowflake"],
    29: ["line.facility.desk", "fill.facility.desk"],
    30: ["line.electrics.dryer", "fill.electrics.dryer"],
    31: ["line.electrics.wifi-pay", "fill.electrics.wifi-pay"],
    32: ["line.electrics.internet-wire-pay", "fill.electrics.internet-wire-pay"],
    33: ["line.electrics.iron", "fill.electrics.iron"],
    35: ["line.electrics.tv", "fill.electrics.tv"],
    44: ["line.electrics.tv-cable", "fill.electrics.tv-cable"],
    47: ["line.electrics.coffee-maker", "fill.electrics.coffee-maker"],
    50: ["line.facility.pool-indoor", "fill.facility.pool-indoor"],
    52: ["line.facility.pool-indoor", "fill.facility.pool-indoor"],
    54: ["line.facility.hot-spring", "fill.facility.hot-spring"],
    57: ["line.activity.dumbbell", "fill.activity.dumbbell"],
    58: ["line.facility.sauna", "fill.facility.sauna"],
    61: ["line.facility.spa", "fill.facility.spa"],
    65: ["line.facility.pool-outdoor", "fill.facility.pool-outdoor"],
    75: ["line.electrics.wifi", "fill.electrics.wifi"],
    77: ["line.electrics.internet-wire", "fill.electrics.internet-wire"],
    80: ["line.transportation.car-park", "fill.transportation.car-park"],
    83: ["line.facility.smoke", "fill.facility.smoke"],
    87: ["line.electrics.laundry-wash", "fill.electrics.laundry-wash"],
    116: ["line.service.reception", "fill.service.reception"],
    141: ["line.amenity.toiletries", "fill.amenity.toiletries"],
    143: ["line.electrics.heater", "fill.electrics.heater"],
    149: ["line.electrics.laundry-dry", "fill.electrics.laundry-dry"],
    211: ["line.food.coffee", "fill.food.coffee"],
    212: ["line.food.tea", "fill.food.tea"],
    216: ["line.facility.fireplace", "fill.facility.fireplace"],
    220: ["line.amenity.linen", "fill.amenity.linen"],
    223: ["line.symbol.door", "fill.symbol.door"],
    230: ["line.amenity.towel", "fill.amenity.towel"],
    232: ["line.amenity.hanger", "fill.amenity.hanger"],
    235: ["line.facility.cctv", "fill.facility.cctv"],
    248: ["line.electrics.wifi-pay", "fill.electrics.wifi-pay"],
    272: ["line.amenity.key-no", "fill.amenity.key-no"],
    273: ["line.electrics.intercome", "fill.electrics.intercome"],
    274: ["line.service.doorman", "fill.service.doorman"],
    275: ["line.amenity.kitchenware", "fill.amenity.kitchenware"],
    277: ["line.electrics.smoke-detector", "fill.electrics.smoke-detector"],
    278: ["line.electrics.smoke-detector", "fill.electrics.smoke-detector"],
    279: ["line.facility.firstaid", "fill.facility.firstaid"],
    280: ["line.facility.fire-extinguisher", "fill.facility.fire-extinguisher"],
    281: ["line.facility.smoke", "fill.facility.smoke"],
    351: ["line.food.croissant", "fill.food.croissant"],
    357: ["line.transportation.parking", "fill.transportation.parking"],
    2405: ["line.service.clean", "fill.service.clean"],
    2406: ["line.amenity.sanitizer", "fill.amenity.sanitizer"],
    2407: ["line.service.clean", "fill.service.clean"],
    2408: ["line.service.clean", "fill.service.clean"],
    2409: ["line.amenity.facemask", "fill.amenity.facemask"],
    2410: ["line.amenity.sanitizer", "fill.amenity.sanitizer"],
    2411: ["line.service.clean", "fill.service.clean"],
    2412: ["line.symbol.door-check", "fill.symbol.door-check"],
    2458: ["line.transportation.parking-pay", "fill.transportation.parking-pay"],
    2459: ["line.amenity.toiletries", "fill.amenity.toiletries"],
    2460: ["line.facility.bathtub", "fill.facility.bathtub"],
    2461: ["line.activity.play", "fill.activity.play"],
    2462: ["line.symbol.volume", "fill.symbol.volume"],
    2463: ["line.activity.go-game", "fill.activity.go-game"],
    2464: ["line.facility.baby-cot", "fill.facility.baby-cot"],
    2465: ["line.amenity.baby-safety-gate", "fill.amenity.baby-safety-gate"],
    2466: ["line.facility.chair-kid", "fill.facility.chair-kid"],
    2467: ["line.activity.game", "fill.activity.game"],
    2468: ["line.facility.baby-cot", "fill.facility.baby-cot"],
    2469: ["line.food.fork-knife", "fill.food.fork-knife"],
    2470: ["line.amenity.toy", "fill.amenity.toy"],
    2471: ["line.amenity.baby-changing-room", "fill.amenity.baby-changing-room"],
    2472: ["line.facility.cctv", "fill.facility.cctv"],
    2473: ["line.facility.bathtub", "fill.facility.bathtub"],
    2474: ["line.facility.stove", "fill.facility.stove"],
    2475: ["line.electrics.refrigerator", "fill.electrics.refrigerator"],
    2476: ["line.electrics.microwave", "fill.electrics.microwave"],
    2477: ["line.electrics.microwave", "fill.electrics.microwave"],
    2478: ["line.amenity.kitchenware", "fill.amenity.kitchenware"],
    2479: ["line.electrics.refrigerator", "fill.electrics.refrigerator"],
    2480: ["line.electrics.dishwasher", "fill.electrics.dishwasher"],
    2481: ["line.food.fork-knife", "fill.food.fork-knife"],
    2482: ["line.activity.fish-water", "fill.activity.fish-water"],
    2483: ["line.activity.ski", "fill.activity.ski"],
    2484: ["line.facility.balcony", "fill.facility.balcony"],
    2485: ["line.activity.fish-water", "fill.activity.fish-water"],
    2486: ["line.activity.forest", "fill.activity.forest"],
    2487: ["line.transportation.bike", "fill.transportation.bike"],
    2488: ["line.activity.beach", "fill.activity.beach"],
    2489: ["line.facility.grill", "fill.facility.grill"],
    2490: ["line.electrics.laundry-wash", "fill.electrics.laundry-wash"],
    2491: ["line.electrics.fan", "fill.electrics.fan"],
    2546: ["line.facility.pool-indoor", "fill.facility.pool-indoor"],
    2584: ["line.activity.book", "fill.activity.book"],
    2585: ["line.amenity.facemask", "fill.amenity.facemask"],
    2586: ["line.facility.temperature", "fill.facility.temperature"],
    2587: ["line.amenity.baby-safety-gate", "fill.amenity.baby-safety-gate"],
};
